<template>
  <div id="footer">
    <div class="info">
      <p>
        <router-link to="/pages/terms-use">
          {{ getTitle('footer.termsUse') }}
        </router-link>
        |
        <router-link to="/pages/faq">
          {{ getTitle('footer.FAQ') }}
        </router-link>
        |
        <router-link to="/pages/contact-us">
          {{ getTitle('footer.contactUs') }}
        </router-link>
        |
        <span @click="goMessage()">{{ getTitle('footer.message') }}</span>
        <!-- <router-link to="/pages/message">
          {{ getTitle('footer.message') }}
        </router-link> -->
      </p>
    </div>
    <div class="qrcode">
      <div>
        <img src="../assets/images/qrcode.png" />
        <p>{{ getTitle('footer.Wechat') }}</p>
      </div>
      <div>
        <img src="../assets/images/qrcode.png" />
        <p>{{ getTitle('footer.APP') }}</p>
      </div>
    </div>
    <div class="service">
      <p class="hotline">
        {{ getTitle('footer.phone') }}
      </p>
      <!-- <p class="time">{{ getTitle('footer.time') }}</p> -->
    </div>
    <div class="links">
      <ul>
        <li
          v-for="item in linksList2"
          :key="item.links_id"
          @click="go(item.url)"
        >
          <img :src="item.image" />
          <p>{{ item.title }}</p>
        </li>
      </ul>
    </div>
    <div class="copyright">
      <p>
        <a href="https://beian.miit.gov.cn/" target="_blank">
          {{ getTitle('footer.icp') }}
        </a>
        &copy; {{ getTitle('footer.copyright') }}
      </p>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import _ from 'underscore';
import routerTo from '@/router/routerTo';
import { mapMutations, mapState } from 'vuex';
export default {
  data() {
    return {
      linksList: [],
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    ...mapState({
      isLogin: (state) => state.isLogin,
    }),
    linksList2() {
      return this.localeLinksList(this.locale);
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.getLinksList();
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async getLinksList() {
      const linksListInfo = await www.getLinksList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
      });
      this.linksList = linksListInfo.data.sort((a, b) => a.order - b.order);
    },
    localeLinksList(locale) {
      return _.filter(this.linksList, (cur) => {
        return cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale);
      });
    },
    // goPageInfo(ID) {
    //   routerTo.toPageInfo(this.$router, false, { ID: ID });
    // },
    goMessage() {
      if (!this.isLogin) {
        routerTo.toLogin(this.$router, false);
        return;
      }
      this.$router.push({
        path: '/pages/message',
      });
    },
    go(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
#footer {
  padding-top: 40px;
  border-top: 1px solid #eee;
  text-align: center;
  background: #fff;
  .info {
    margin-bottom: 30px;
    span,
    a {
      margin: 0 8px;
      color: #191b26;
      cursor: pointer;
    }
  }
  .qrcode {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    div {
      margin: 0 20px;
      img {
        width: 80px;
        height: 80px;
      }
      p {
        padding-top: 10px;
      }
    }
  }
  .service {
    margin-bottom: 30px;
    .hotline {
      display: inline-block;
      margin-bottom: 20px;
      padding: 10px 30px;
      border-radius: 20px;
      color: #fff;
      background: #31a775;
      span {
        display: inline-block;
        padding-left: 30px;
        background: url(../assets/images/icon-phone.png) no-repeat 0 50%;
        background-size: 24px 24px;
      }
    }
    .time {
      color: #515457;
      font-size: 12px;
    }
  }
  .links {
    margin-bottom: 30px;
    ul {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      li {
        display: flex;
        align-items: center;
        width: 180px;
        padding: 10px 15px;
        border-radius: 4px;
        color: #515457;
        background: #f8f8f8;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }
    }
  }
  .copyright {
    padding: 10px 0;
    color: #fff;
    background: #31a775;
    a {
      color: #fff;
    }
  }
}
</style>
